import { CommonModule, SlicePipe } from '@angular/common';
import { CurrencyPipe } from './currency.pipe';
import { NgModule } from '@angular/core';
import { TranslatePipe } from './translate.pipe';
import { HighlightPipe } from './string/highlight.pipe';
import { StrSlicePipe } from './string/slice.pipe';
import { PhonePipe } from './string/phone.pipe';
import { BooleanPipe } from './boolean.pipe';
import { TranslateManyPipe } from './string/translate-many.pipe';
import { PositionTitlePipe } from './oss/position-title.pipe';
import { StrListPipe } from './string/list.pipe';
import { TimesPipe } from './template/times.pipe';
import { CallbackPipe } from './template/callback.pipe';
import { ContainsPipe } from './contains.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [
        CurrencyPipe,
        TranslatePipe,
        HighlightPipe,
        StrSlicePipe,
        PhonePipe,
        BooleanPipe,
        TranslateManyPipe,
        PositionTitlePipe,
        StrListPipe,
        TimesPipe,
        CallbackPipe,
        ContainsPipe
    ],
    exports: [
        CurrencyPipe,
        TranslatePipe,
        HighlightPipe,
        StrSlicePipe,
        PhonePipe,
        BooleanPipe,
        TranslateManyPipe,
        PositionTitlePipe,
        StrListPipe,
        TimesPipe,
        CallbackPipe,
        ContainsPipe
    ],
    providers: [
        SlicePipe,
        StrSlicePipe,
        TranslateManyPipe
    ]
})
export class PipesModule {}